import { FC, JSX } from 'react';

import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@/app/libs';

type QueryProviderProps = {
  children: JSX.Element | JSX.Element[];
};

const QueryProvider: FC<QueryProviderProps> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export { QueryProvider };
